var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-add-services" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-block emergo-green-button",
            on: { click: _vm.goToMarketPlace },
          },
          [
            _c("img", {
              staticClass: "add_icon_img",
              attrs: {
                src: "/static/images/icons/plus_icon.svg",
                alt: "plus-icon",
              },
            }),
            _vm._v(" Add "),
            _c("span", { staticClass: "hidden-xs" }, [_vm._v("More Services")]),
          ]
        ),
      ]),
      _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12 box-wrapper" }, [
        _c("div", [
          _c("div", { staticClass: "acct-service" }, [_vm._v("Account")]),
          _c("hr", { staticClass: "upper-line" }),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-lg-7 col-md-8 col-sm-7 col-xs-6 team-members",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 pl-0",
                    class: {
                      "col-md-5 col-lg-5": _vm.restrictedUsersCount > 0,
                    },
                  },
                  [
                    _c("div", { staticClass: "team-member-reg" }, [
                      _vm._v("Team Members"),
                    ]),
                    Object.keys(_vm.teamMember).length
                      ? _c("div", { staticClass: "records-available" }, [
                          _c("span", { staticClass: "available-item" }, [
                            _vm.isREP
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.teamMember.current_utilization - 1 >=
                                        _vm.teamLimit
                                        ? 0
                                        : _vm.teamLimit -
                                            (_vm.teamMember
                                              .current_utilization -
                                              1)
                                    ) +
                                      " of " +
                                      _vm._s(_vm.teamLimit)
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.teamMember.current_utilization >=
                                        _vm.teamLimit
                                        ? 0
                                        : _vm.teamLimit -
                                            _vm.teamMember.current_utilization
                                    ) +
                                      " of " +
                                      _vm._s(_vm.teamLimit)
                                  ),
                                ]),
                          ]),
                          _c("span", { staticClass: "available-upto" }, [
                            _vm._v(" available"),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm.restrictedUsersCount > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-md-7 col-lg-7 col-xs-12 pl-0 display-flex hidden-xs font-16",
                      },
                      [_vm._m(0), _vm._m(1)]
                    )
                  : _vm._e(),
                _vm.teamMember.total_limit > _vm.teamMember.default_limit
                  ? _c("div", { staticClass: "col-xs-12 pl-0 free-renews" }, [
                      _vm.teamMember.expiry_date
                        ? _c("span", { staticClass: "expiration-title" }, [
                            _c("img", {
                              staticClass: "traingle-alert",
                              attrs: {
                                src: "/static/images/icons/alert_triangle.svg",
                                alt: "alert-icon",
                              },
                            }),
                            _c("b", [_vm._v("Expires")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.teamMember.expiry_date
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _c("span", [
                            _c("span", [_vm._v("Expires on ")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.teamMember.valid_until
                                  )
                                ) +
                                " "
                            ),
                          ]),
                    ])
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-lg-5 col-md-4 col-sm-5 col-xs-6 pl-0 small-update-service position-relative",
              },
              [
                _vm.teamPrice
                  ? _c("div", { staticClass: "upgrade-service" }, [
                      _vm._v("$" + _vm._s(_vm.teamPrice) + " per year"),
                    ])
                  : _vm._e(),
                !_vm.teamMember.expiry_date && !_vm.teamMember.renewed
                  ? _c("div", { staticClass: "upgrade-service" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn emergo-white-button",
                          attrs: {
                            "data-toggle": "modal",
                            "data-target": "#UpgradeModal",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.upgradeService("", "account")
                            },
                          },
                        },
                        [_vm._v(" Upgrade Account ")]
                      ),
                    ])
                  : _vm._e(),
                _vm.teamMember.expiry_date && !_vm.teamMember.renewed
                  ? _c(
                      "div",
                      { staticClass: "upgrade-service upgrade-service-btn" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn emergo-green-button",
                            attrs: {
                              "data-toggle": "modal",
                              "data-target": "#renewModal",
                            },
                          },
                          [_vm._v(" Renew Members ")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.teamMember.renewed
                  ? _c("div", { staticClass: "renew-class top_28" }, [
                      _c("img", {
                        staticClass: "success_logo card-img-top",
                        attrs: {
                          src: "static/images/icons/checkbox.svg",
                          alt: "checkbox-tick-icon",
                        },
                      }),
                      _c("br"),
                      _c("span", { staticClass: "pt-10" }, [
                        _vm._v(" Renewed "),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "row m-0" }, [
          _c(
            "div",
            {
              staticClass:
                "col-lg-5 col-md-5 col-sm-5 col-xs-4 acct-service pt-15",
            },
            [_vm._v("Services")]
          ),
          _c(
            "div",
            {
              staticClass:
                "col-lg-7 col-md-7 col-sm-7 col-xs-7 p-0 align-right",
            },
            [
              _vm.displayRenewAll && !_vm.isREP
                ? _c(
                    "button",
                    {
                      staticClass: "btn emergo-blue-button renew-service",
                      on: {
                        click: function ($event) {
                          return _vm.renewExpiringServices()
                        },
                      },
                    },
                    [_vm._v(" Renew all services expiring ")]
                  )
                : _vm._e(),
            ]
          ),
        ]),
        _vm.planList &&
        _vm.planList.length > 0 &&
        (!(
          !_vm.isREP &&
          _vm.isProductClassificationActive &&
          _vm.planList.length === 1
        ) ||
          (_vm.isREP &&
            !_vm.planList
              .map((a) => a.id)
              .every((ele) => [1, 2, 4, 7].includes(ele))))
          ? _c("div", { staticClass: "row m-0" }, [
              _c("hr", { staticClass: "upper-line-services" }),
              _vm._m(2),
            ])
          : _vm._e(),
        _vm.planList && _vm.planList.length > 0
          ? _c(
              "div",
              [
                _vm._l(_vm.planList, function (service, key) {
                  return _c("div", { key: key }, [
                    service.id !== 5 &&
                    !(
                      service.id == 7 &&
                      _vm.activeProdClassCount > 0 &&
                      service.service_type === "trial"
                    )
                      ? _c(
                          "div",
                          {
                            class: {
                              "min-ht-100": service.id === 4 && service.renewed,
                            },
                          },
                          [
                            _c("hr", { staticClass: "upper-line-services" }),
                            _c("div", { staticClass: "row ml-5" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-9 col-md-9 col-sm-9 col-xs-8",
                                },
                                [
                                  _c("img", {
                                    staticClass: "check-icon",
                                    attrs: {
                                      src: "/static/images/icons/circle_check.svg",
                                      alt: "check-icon",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "service-name",
                                      class: {
                                        fnt_14:
                                          service.id === 13 ||
                                          service.id === 14,
                                      },
                                    },
                                    [_vm._v(_vm._s(service.name))]
                                  ),
                                ]
                              ),
                              !_vm.isREP
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-3 col-md-3 col-sm-3 col-xs-4 dollar-year",
                                    },
                                    [
                                      service.id === 1 ||
                                      service.id === 13 ||
                                      service.id === 14
                                        ? _c(
                                            "div",
                                            { staticClass: "upgrade-service" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "inline-service",
                                                },
                                                [
                                                  _vm._v(
                                                    "$" + _vm._s(service.price)
                                                  ),
                                                ]
                                              ),
                                              _vm.recordPrice > 0
                                                ? _c("span", [
                                                    _vm._v(
                                                      "+ $" +
                                                        _vm._s(_vm.recordPrice)
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" per year "),
                                            ]
                                          )
                                        : service.id === 2 &&
                                          service.service_type === "premium"
                                        ? _c(
                                            "div",
                                            { staticClass: "upgrade-service" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(service.price) +
                                                    " per year"
                                                ),
                                              ]),
                                            ]
                                          )
                                        : service.id !== 2
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "upgrade-service",
                                              class: {
                                                "mb-0":
                                                  service.id === 15 ||
                                                  service.id === 16,
                                              },
                                            },
                                            [
                                              service.id === 9 ||
                                              service.id === 10 ||
                                              service.id === 12
                                                ? _c("span", [
                                                    _vm._v(
                                                      "$" +
                                                        _vm._s(service.price) +
                                                        "/use"
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "$" +
                                                        _vm._s(service.price) +
                                                        " per year"
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isREP
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-3 col-md-3 col-sm-3 col-xs-4 dollar-year",
                                    },
                                    [
                                      service.id !== 2
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "upgrade-service",
                                              class: {
                                                "mb-0":
                                                  service.id === 15 ||
                                                  service.id === 16,
                                              },
                                            },
                                            [
                                              service.id === 9 ||
                                              service.id === 10 ||
                                              service.id === 12
                                                ? _c("span", [
                                                    _vm._v(
                                                      "$" +
                                                        _vm._s(service.price) +
                                                        "/use"
                                                    ),
                                                  ])
                                                : service.id === 15 ||
                                                  service.id === 16
                                                ? _c("span", [
                                                    _vm._v(
                                                      "$" +
                                                        _vm._s(service.price) +
                                                        " per year"
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            service.id === 2
                              ? _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-offset-1 col-lg-offset-1 col-sm-offset-1 col-lg-11 col-md-11 col-sm-11 col-xs-11",
                                    },
                                    [
                                      _vm.regIntellMarket === "all"
                                        ? _c("div", { staticClass: "mb-5" }, [
                                            _vm._v("All markets included"),
                                          ])
                                        : _vm._e(),
                                      _vm.regIntellMarket === "multiple" ||
                                      (_vm.isDefaultMarket &&
                                        _vm.regIntellMarket !== "all")
                                        ? [
                                            _c("div", { staticClass: "mb-5" }, [
                                              _vm._v("Selected markets"),
                                            ]),
                                            _vm._l(
                                              _vm.displayCountries,
                                              function (country, index) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "available-upto",
                                                  },
                                                  [
                                                    _vm._v(_vm._s(country)),
                                                    _vm.displayCountries
                                                      .length >
                                                    index + 1
                                                      ? _c("span", [
                                                          _vm._v(", "),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm.viewMore &&
                                            _vm.countries.length > 5
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "cust-link",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.viewMore = false
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(",... View more")]
                                                )
                                              : _vm._e(),
                                            !_vm.viewMore &&
                                            _vm.countries.length > 5
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "cust-link",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.viewMore = true
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" View less")]
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "row position-relative",
                                class: { min_hght_32: service.renewed },
                              },
                              [
                                service.id === 1 ||
                                service.id === 13 ||
                                service.id === 14
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-offset-1 col-xs-8 reg-records",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "registration-records",
                                          },
                                          [_vm._v("Registrations Records")]
                                        ),
                                        Object.keys(_vm.records).length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "records-available",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "available-item",
                                                  },
                                                  [
                                                    _vm.records.total_limit >=
                                                      _vm.records
                                                        .default_limit &&
                                                    _vm.records.is_active &&
                                                    _vm.todayDate() <=
                                                      _vm.$options.filters.serviceExpDateFormat(
                                                        _vm.records.valid_until
                                                      ) &&
                                                    _vm.todayDate() >=
                                                      _vm.$options.filters.serviceExpDateFormat(
                                                        _vm.records.valid_from
                                                      )
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.records
                                                                .total_limit -
                                                                _vm.records
                                                                  .current_utilization
                                                            ) +
                                                              " of " +
                                                              _vm._s(
                                                                _vm.records
                                                                  .total_limit
                                                              )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.records
                                                                .default_limit -
                                                                _vm.records
                                                                  .current_utilization
                                                            ) +
                                                              " of " +
                                                              _vm._s(
                                                                _vm.records
                                                                  .default_limit
                                                              )
                                                          ),
                                                        ]),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "available-upto",
                                                  },
                                                  [_vm._v(" available")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.regIntellMarket === "all" &&
                                        (service.id === 13 || service.id === 14)
                                          ? _c(
                                              "div",
                                              { staticClass: "mb-5 pt-10" },
                                              [
                                                _vm._v(
                                                  " Regulatory Intelligence all markets included "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        service.id === 14
                                          ? _c(
                                              "div",
                                              { staticClass: "mb-5 pt-10" },
                                              [
                                                _vm._v(
                                                  " Regulatory Reports all markets included "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                service.service_type === "premium" &&
                                (service.id === 9 || service.id === 10)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-offset-1 col-xs-11 reg-records",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "registration-records",
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(service.name) + " usage"
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "records-available" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "available-item" },
                                              [
                                                service.id === 9
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.rationaleRepUtil
                                                            .total_limit -
                                                            _vm.rationaleRepUtil
                                                              .current_utilization
                                                        ) +
                                                          " of " +
                                                          _vm._s(
                                                            _vm.rationaleRepUtil
                                                              .total_limit
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                service.id === 10
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .rationaleRepEmergoUtil
                                                            .total_limit -
                                                            _vm
                                                              .rationaleRepEmergoUtil
                                                              .current_utilization
                                                        ) +
                                                          " of " +
                                                          _vm._s(
                                                            _vm
                                                              .rationaleRepEmergoUtil
                                                              .total_limit
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "available-upto",
                                                  },
                                                  [_vm._v(" available ")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                service.id === 16
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-offset-1 col-sm-5 col-xs-11 reg-records",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "registration-records",
                                            class: {
                                              "mt-20": service.expiry_date,
                                            },
                                          },
                                          [_vm._v(" All Markets Available ")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                service.id === 15 || service.id === 13
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-offset-1 col-sm-5 col-xs-11 reg-records",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "registration-records pt-16",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.selectedCountryList.length
                                                ) +
                                                " Markets added out of 3 available markets "
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "mt-5" }, [
                                          _c(
                                            "ul",
                                            { staticClass: "regreport-ul" },
                                            [
                                              _c("li", [
                                                _vm._v(
                                                  "Current Markets: " +
                                                    _vm._s(_vm.getCountriesList)
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                (service.id === 15 || service.id === 13) &&
                                _vm.subscribedMarkets.length < 3
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-6 col-xs-offset-1 col-sm-offset-0 col-xs-11",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-mrkt renew-service",
                                          },
                                          [
                                            _vm._v(
                                              " Select Markets (Up to 3 markets can be selected) "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "multiselect",
                                          {
                                            staticClass:
                                              "multiselect-single-dropdown multiselect-multiple wd-80 renew-service",
                                            class: !_vm.selectedCountryList
                                              .length
                                              ? "un-selected"
                                              : "",
                                            attrs: {
                                              disabled:
                                                _vm.regReportMarketSelection ==
                                                  "allMarkets" ||
                                                _vm.selectedCountryList.length >
                                                  3,
                                              showLabels: false,
                                              "close-on-select": false,
                                              placeholder: "Select Market(s)",
                                              label: "country_name",
                                              "track-by": "country_name",
                                              multiple: true,
                                              searchable: true,
                                              "clear-on-select": false,
                                              options: _vm.unsubscribedMarkets,
                                              value: _vm.selectedCountryList,
                                            },
                                            on: {
                                              close: function ($event) {
                                                return _vm.countryListUpdates(
                                                  service
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function ({
                                                    values,
                                                    isOpen,
                                                  }) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "selection-count",
                                                      },
                                                      [
                                                        !isOpen
                                                          ? [
                                                              _c("img", {
                                                                staticClass:
                                                                  "image-size",
                                                                attrs: {
                                                                  src: "/static/images/icons/filter.svg",
                                                                  alt: "filter-icon",
                                                                },
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "selected-count",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      values.length
                                                                    ) +
                                                                      " Selected"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : isOpen
                                                          ? [
                                                              _c("img", {
                                                                staticClass:
                                                                  "image-size",
                                                                attrs: {
                                                                  src: "/static/images/icons/filter.svg",
                                                                  alt: "filter-icon",
                                                                },
                                                              }),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  },
                                                },
                                                {
                                                  key: "option",
                                                  fn: function (props) {
                                                    return _c("span", {}, [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "d-flex",
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.updateSelectedCountryList(
                                                                props.option,
                                                                "reg-report"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "checkbox inline-checkbox",
                                                            },
                                                            [
                                                              _c("label", [
                                                                _c("input", {
                                                                  attrs: {
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      props
                                                                        .option
                                                                        .country_name,
                                                                    checked:
                                                                      _vm.selectedCountryList.includes(
                                                                        props.option
                                                                      ),
                                                                  },
                                                                }),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "cr",
                                                                  class: {
                                                                    "disabled-checkbox":
                                                                      _vm
                                                                        .selectedCountryList
                                                                        .length ==
                                                                      3,
                                                                  },
                                                                }),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              class: {
                                                                "font-bold":
                                                                  _vm.selectedCountryList.includes(
                                                                    props.option
                                                                  ),
                                                                "font-wt-400":
                                                                  !_vm.selectedCountryList.includes(
                                                                    props.option
                                                                  ),
                                                                "disabled-text":
                                                                  _vm
                                                                    .selectedCountryList
                                                                    .length ==
                                                                  3,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateSelectedCountryList(
                                                                      props.option,
                                                                      "reg-report"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    props.option
                                                                      .country_name
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "noResult" },
                                                slot: "noResult",
                                              },
                                              [_vm._v("No matching data")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                service.renewed && !service.renewedBundle
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "renew-class",
                                        class: {
                                          "renew-class-2":
                                            service.id === 2 ||
                                            service.id === 15,
                                          "renew-class-3": service.id === 16,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "success_logo card-img-top",
                                          attrs: {
                                            src: "static/images/icons/checkbox.svg",
                                            alt: "checkbox-icon",
                                          },
                                        }),
                                        _c("br"),
                                        _c("span", { staticClass: "pt-10" }, [
                                          _vm._v(" Renewed "),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            service.id === 15
                              ? _c("div", { staticClass: "row mr-0" }, [
                                  _vm._m(3, true),
                                ])
                              : _vm._e(),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-offset-1 col-lg-6 col-md-5 col-sm-5 col-xs-11 free-service-renews",
                                },
                                [
                                  !_vm.isREP && service.id != 2
                                    ? _c(
                                        "div",
                                        { staticClass: "free-renews" },
                                        [
                                          service.expiry_date
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "expiration-title",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "traingle-alert",
                                                    attrs: {
                                                      src: "/static/images/icons/alert_triangle.svg",
                                                      alt: "alert-icon",
                                                    },
                                                  }),
                                                  _c("b", [_vm._v("Expires")]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("dateFormat")(
                                                          service.expiry_date
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                service.id === 3
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Until " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFormat"
                                                            )(
                                                              service.valid_until
                                                            )
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                service.id !== 3 &&
                                                service.id !== 7 &&
                                                (service.service_type ===
                                                  "trial" ||
                                                  service.service_type ===
                                                    "trail")
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Trial ends " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFormat"
                                                            )(
                                                              service.valid_until
                                                            )
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                service.id !== 3 &&
                                                service.service_type ===
                                                  "premium"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " Expires on " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFormat"
                                                            )(
                                                              service.valid_until
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isREP &&
                                  [9, 10, 15, 16].includes(service.id)
                                    ? _c(
                                        "div",
                                        { staticClass: "free-renews" },
                                        [
                                          service.expiry_date
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "expiration-title",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "traingle-alert",
                                                    attrs: {
                                                      src: "/static/images/icons/alert_triangle.svg",
                                                      alt: "alert-icon",
                                                    },
                                                  }),
                                                  _c("b", [_vm._v("Expires")]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("dateFormat")(
                                                          service.expiry_date
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                service.id !== 3 &&
                                                (service.service_type ===
                                                  "trial" ||
                                                  service.service_type ===
                                                    "trail")
                                                  ? _c("span", [
                                                      _vm._v("Trial ends"),
                                                    ])
                                                  : _vm._e(),
                                                service.service_type ===
                                                "premium"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Expires on " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFormat"
                                                            )(
                                                              service.valid_until
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  !_vm.isREP &&
                                  service.id == 2 &&
                                  ((_vm.countries &&
                                    _vm.countries.length > 1 &&
                                    _vm.isDefaultMarket) ||
                                    (_vm.countries &&
                                      _vm.countries.length > 0 &&
                                      !_vm.isDefaultMarket) ||
                                    _vm.allMarketsSelected)
                                    ? _c(
                                        "div",
                                        { staticClass: "free-renews" },
                                        [
                                          service.expiry_date
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "expiration-title",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "traingle-alert",
                                                    attrs: {
                                                      src: "/static/images/icons/alert_triangle.svg",
                                                      alt: "alert-icon",
                                                    },
                                                  }),
                                                  _c("b", [_vm._v("Expires")]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("dateFormat")(
                                                          service.expiry_date
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                service.service_type ===
                                                "premium"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Expires on " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFormat"
                                                            )(
                                                              service.valid_until
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isREP
                                    ? _c(
                                        "div",
                                        { staticClass: "free-renews" },
                                        [
                                          service.id !== 3 &&
                                          service.id !== 15 &&
                                          service.id !== 16 &&
                                          service.id !== 9 &&
                                          service.id !== 10
                                            ? _c("span", [
                                                _vm._v(
                                                  "Included with your In-country Representation service"
                                                ),
                                              ])
                                            : _vm._e(),
                                          service.id === 3
                                            ? _c("span", [
                                                service.expiry_date
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "expiration-title",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "traingle-alert",
                                                          attrs: {
                                                            src: "/static/images/icons/alert_triangle.svg",
                                                            alt: "alert-icon",
                                                          },
                                                        }),
                                                        _c("b", [
                                                          _vm._v("Expires"),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "dateFormat"
                                                              )(
                                                                service.expiry_date
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        "Until " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFormat"
                                                            )(
                                                              service.valid_until
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                  service.id === 15
                                    ? _c(
                                        "div",
                                        { staticClass: "free-renews" },
                                        [
                                          _vm._v(
                                            " Upgrade to report access to all markets "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-offset-1 col-sm-offset-0 col-lg-5 col-md-6 col-sm-6 col-xs-6",
                                },
                                [
                                  service &&
                                  service.service_type === "premium" &&
                                  !service.expiry_date &&
                                  !service.renewed &&
                                  !service.renewedBundle &&
                                  service.id === 1
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-white-button",
                                                attrs: {
                                                  "data-toggle": "modal",
                                                  "data-target":
                                                    "#UpgradeModal",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.upgradeService(
                                                      service,
                                                      "service"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Upgrade service ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  service &&
                                  service.service_type === "premium" &&
                                  !service.expiry_date &&
                                  !service.renewed &&
                                  !service.renewedBundle &&
                                  service.id === 13
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-white-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.payForService(
                                                      service
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Upgrade service ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  service.id === 3 && _vm.projectsList.length
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-white-button",
                                                attrs: {
                                                  "data-toggle": "modal",
                                                  "data-target":
                                                    "#SBRenewalPopup",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.SBRenewalPopup(
                                                      service
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Contact Us to Renew ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  !_vm.isREP &&
                                  service.expiry_date &&
                                  !service.renewed &&
                                  !service.renewedBundle &&
                                  service.service_type === "premium" &&
                                  (service.id === 1 ||
                                    service.id === 2 ||
                                    service.id === 4 ||
                                    service.id === 6 ||
                                    service.id === 7 ||
                                    service.id === 13 ||
                                    service.id === 14)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-green-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.renewService(
                                                      service
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Renew service ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  service.expiry_date &&
                                  !service.renewed &&
                                  !service.renewedBundle &&
                                  service.service_type === "premium" &&
                                  (service.id === 15 || service.id === 16)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-green-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.renewService(
                                                      service
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Renew service ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  service &&
                                  service.id === 2 &&
                                  service.service_type == "trial"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-white-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.payForService(
                                                      service
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Purchase service ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  service &&
                                  !service.expiry_date &&
                                  !service.renewed &&
                                  service.id === 2 &&
                                  (_vm.isDefaultMarket ||
                                    (_vm.countries &&
                                      _vm.countries.length > 0)) &&
                                  !_vm.allMarketsSelected
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-white-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.payForService(
                                                      service
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Upgrade service ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  service &&
                                  service.service_type !== "premium" &&
                                  service.id !== 2 &&
                                  !service.renewed
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-white-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.payForService(
                                                      service
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Purchase service ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  service &&
                                  service.service_type === "premium" &&
                                  service.id === 15 &&
                                  !service.expiry_date &&
                                  !service.renewed
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-white-button",
                                                attrs: {
                                                  "data-toggle": "modal",
                                                  "data-target":
                                                    "#regReportUpgradeModal",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.upgradeService(
                                                      service,
                                                      "regreportservice"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Upgrade service ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  service &&
                                  service.service_type === "premium" &&
                                  (service.id === 9 ||
                                    service.id === 10 ||
                                    service.id === 12)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "upgrade-service upgrade-service-btn",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn emergo-white-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.payForService(
                                                      service
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "purchase-more",
                                                  },
                                                  [_vm._v("Purchase more")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                            service.id !== 2
                              ? _c("div", { staticClass: "row" }, [
                                  service.id === 3 && _vm.projectsList.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xs-offset-1 col-lg-8 col-md-8 col-sm-8 free-service-renews col-xs-11",
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "free-renews" },
                                            [
                                              _vm._v(
                                                " View only mode after project completion unless renewed annually "
                                              ),
                                            ]
                                          ),
                                          _vm.getExpiringProjectsCount()
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "expiration-title",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "traingle-alert",
                                                    attrs: {
                                                      src: "/static/images/icons/alert_triangle.svg",
                                                      alt: "alert-icon",
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Expiring soon " +
                                                        _vm._s(
                                                          _vm.getExpiringProjectsCount()
                                                        ) +
                                                        " project(s)"
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ])
                }),
                !_vm.isREP &&
                _vm.isProductClassificationActive &&
                _vm.planList.length === 1
                  ? [
                      _c("div", { staticClass: "row m-0" }, [
                        _c("hr", { staticClass: "upper-line-services" }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-25",
                          },
                          [
                            _c("notification-no-service", {
                              on: {
                                closepopup: function ($event) {
                                  return _vm.$emit("closepopup")
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _c("div", { staticClass: "row m-0" }, [
              _c("hr", { staticClass: "upper-line-services" }),
              _c(
                "div",
                {
                  staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-25",
                },
                [
                  _c("notification-no-service", {
                    on: {
                      closepopup: function ($event) {
                        return _vm.$emit("closepopup")
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c("renew-modal", {
        on: { payForUpgradeService: _vm.payForUpgradeService },
      }),
      _c("upgrade-modal", {
        attrs: {
          selectedService: _vm.selectedService,
          addonType: _vm.addonType,
        },
        on: { payForUpgradeService: _vm.payForUpgradeService },
      }),
      _c("reg-report-upgrade-modal", {
        attrs: {
          selectedService: _vm.selectedService,
          addonType: _vm.addonType,
        },
        on: { payForUpgradeService: _vm.payForUpgradeService },
      }),
      _c("confirmation-modal", {
        attrs: { selectedService: _vm.selectedService },
      }),
      _c("sb-contact-renewal-modal", {
        attrs: {
          selectedService: _vm.selectedService,
          projectsList: _vm.projectsList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert-image" }, [
      _c("span", { staticClass: "tooltiptext" }, [
        _vm._v(
          "Your Team Member upgrade has expired. Every RAMS account can have up to 5 free users. Navigate to your team list to unblock up to 4 additional team members. For 5+ member access, upgrade your account at any time from the Services page under Account Settings."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Your Account has "),
      _c("br"),
      _vm._v(" restricted team members"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 text-secondary" }, [
      _c("div", [
        _c("img", {
          staticClass: "check-icon-size",
          attrs: { src: "/static/images/icons/check.svg", alt: "check-icon" },
        }),
        _c("span", { staticClass: "pl-10" }, [
          _vm._v("Purchased Services need to be manually renewed."),
        ]),
      ]),
      _c("div", { staticClass: "pt-10" }, [
        _c("img", {
          staticClass: "check-icon-size",
          attrs: { src: "/static/images/icons/check.svg", alt: "check-icon" },
        }),
        _c("span", { staticClass: "pl-10" }, [
          _vm._v(
            "Please renew prior to the expiration date to ensure uninterrupted access."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-sm-offset-1 col-sm-11 col-xs-12 pl-0" },
      [_c("hr", { staticClass: "upper-line-services" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }